import React, { useState } from 'react';

const Tutorials: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState('');

  const handleOpenModal = (videoUrl: string) => {
    setCurrentVideo(videoUrl);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentVideo('');
  };

  const tutorials = [
    {
      title: "Crear Pedidos",
      description: "Aprende a crear pedidos.",
      videoUrl: "https://admin.pedidosmdm.com/videos/crear_pedido.mp4",
      previewImage: "/preview.webp"
    },
    {
      title: "Ver & Editar Pedidos",
      description: "Aprende a cver y gestionar pedidos en el sistema.",
      videoUrl: "https://admin.pedidosmdm.com/videos/ver_editar_pedidos.mp4",
      previewImage: "/preview.webp"
    },
    {
      title: "Gestión de Guias",
      description: "Aprende a gestionar elas guias de cada pediodo",
      videoUrl: "https://admin.pedidosmdm.com/videos/generar_guias.mp4",
      previewImage: "/preview.webp"
    },
    {
      title: "Filtros de Pedido",
      description: "Aprende a utilizar los filtros para encontrar pedidos específicos.",
      videoUrl: "https://admin.pedidosmdm.com/videos/filtro_pedidos.mp4",
      previewImage: "/preview.webp"
    },
    {
      title: "Crear Producto",
      description: "Aprende a crear y gestionar productos en el sistema.",
      videoUrl: "https://admin.pedidosmdm.com/videos/crear_producto.mp4",
      previewImage: "/preview.webp"
    }
  ];

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Tutoriales</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {tutorials.map((tutorial, index) => (
          <div key={index} className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-lg font-semibold mb-2">{tutorial.title}</h2>
            <div className="relative mb-4">
              <img 
                src={tutorial.previewImage} 
                alt='' 
                className="w-full h-48 object-cover rounded"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div 
                  className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-600" 
                  onClick={() => handleOpenModal(tutorial.videoUrl)}
                >
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M6.3 2.841A1.5 1.5 0 004 4.11v11.78a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                  </svg>
                </div>
              </div>
            </div>
            <p className="text-gray-600 mb-4">{tutorial.description}</p>
            <button 
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              onClick={() => handleOpenModal(tutorial.videoUrl)}
            >
              Ver Video
            </button>
          </div>
        ))}
      </div>

      {/* Modal para el video */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg w-full max-w-4xl">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">
                {tutorials.find(t => t.videoUrl === currentVideo)?.title}
              </h3>
              <button 
                onClick={handleCloseModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="aspect-w-16 aspect-h-9">
              <video 
                controls 
                className="w-full h-full"
                src={currentVideo}
              >
                Tu navegador no soporta el elemento de video.
              </video>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tutorials; 